import axios from '@axios'

export default {
  namespaced: true,
  actions: {
    fetchLog(ctx, data) {
      return new Promise((resolve, reject) => {
        axios.get(`logs`, { params: data})
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },

    fetchLogFilters(ctx) {
      return new Promise((resolve, reject) => {
        axios.get(`filters/getFilterBy?type=log`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
  },
}
